import React__default, { useContext, createContext, useReducer, useCallback } from 'react';

const sheetReducer = (state, action) => {
  switch (action.type) {
    case 'add':
      {
        const {
          openedSheet
        } = action;
        const index = state.openedSheets.findIndex(({
          id
        }) => id === openedSheet.id);
        if (index >= 0) {
          return {
            ...state,
            openedSheets: state.openedSheets.map((sheet, i) => {
              if (i === index) {
                return {
                  ...sheet,
                  ...openedSheet
                };
              }
              return sheet;
            })
          };
        }
        return {
          ...state,
          openedSheets: [openedSheet, ...state.openedSheets]
        };
      }
    case 'remove':
      {
        const {
          openedSheetId
        } = action;
        return {
          ...state,
          openedSheets: state.openedSheets.filter(({
            id
          }) => id !== openedSheetId)
        };
      }
    default:
      {
        return state;
      }
  }
};
const SheetContext = /*#__PURE__*/createContext(undefined);
const SheetContextProvider = ({
  children
}) => {
  const sheetContext = useContext(SheetContext);
  const [{
    openedSheets
  }, dispatch] = useReducer(sheetReducer, {
    openedSheets: []
  });
  const addOpenedSheet = useCallback(openedSheet => {
    dispatch({
      type: 'add',
      openedSheet
    });
  }, []);
  const removeOpenedSheet = useCallback(openedSheetId => {
    dispatch({
      type: 'remove',
      openedSheetId
    });
  }, []);
  if (sheetContext) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  }
  return /*#__PURE__*/React__default.createElement(SheetContext.Provider, {
    value: {
      openedSheets,
      addOpenedSheet,
      removeOpenedSheet
    }
  }, children);
};
const defaultContext = {
  openedSheets: [],
  addOpenedSheet: () => undefined,
  removeOpenedSheet: () => undefined
};
const useOpenSheets = () => {
  const context = useContext(SheetContext);
  return context !== null && context !== void 0 ? context : defaultContext;
};

export { SheetContextProvider as S, useOpenSheets as u };
//# sourceMappingURL=SheetContext-DthRk6uR.js.map
